/**
 * @scada/api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.29.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type LastRefreshRequestTypeAnyOf1 = 'current_yield';

export const LastRefreshRequestTypeAnyOf1 = {
    CurrentYield: 'current_yield' as LastRefreshRequestTypeAnyOf1
};

